module.exports = __webpack_public_path__ + "media/images/sp-about-head-3f057f52cfbce3ede4aeadc325f26e77.png";